export const ACM_PROBABILITY = [{
  name: 'ACMHighlyLikely',
  label: 'Highly Likely',
  value: '1'
}, {
  name: 'ACMLikely',
  label: 'Likely',
  value: '2'
}, {
  name: 'ACMUnlikely',
  label: 'Unlikely',
  value: '3'
}, {
  name: 'ACMHighlyUnlikely',
  label: 'Highly Unlikely',
  value: '4'
}]
export const MATERIAL_CONDITION = [{
  name: 'MaterialPoor',
  label: 'Poor',
  value: '1'
}, {
  name: 'MaterialAverage',
  label: 'Average',
  value: '2'
}, {
  name: 'MaterialGood',
  label: 'Good',
  value: '3'
}]
export const FRIABLE = [{
  name: 'FriableYes',
  label: 'Yes',
  value: '1'
}, {
  name: 'FriableNo',
  label: 'No',
  value: '2'
}, {
  name: 'FriableN/A',
  label: 'N/A',
  value: '3'
}]
export const APPROX_COVERAGE = [{
  name: 'Approx<10sqm',
  label: '< 10sqm',
  value: '1'
}, {
  name: 'Approx>10sqm',
  label: '> 10sqm',
  value: '2'
}]
export const PROBABILITY_DISTURBANCE = [{
  name: 'ProbabilityHigh',
  label: 'High',
  value: '1'
}, {
  name: 'ProbabilityMedium',
  label: 'Medium',
  value: '2'
}, {
  name: 'ProbabilityLow',
  label: 'Low',
  value: '3'
}, {
  name: 'ProbabilityN/A',
  label: 'N/A',
  value: '4'
}]
export const PROBABILITY_EXPOSURE = [{
  name: 'ExpHigh',
  label: 'High',
  value: '1'
}, {
  name: 'ExpMedium',
  label: 'Medium',
  value: '2'
}, {
  name: 'ExpLow',
  label: 'Low',
  value: '3'
}, {
  name: 'ExpN/A',
  label: 'N/A',
  value: '4'
}]
export const RISK_LEVEL = [{
  name: 'R1',
  label: 'R1',
  value: '1'
}, {
  name: 'R2',
  label: 'R2',
  value: '2'
}, {
  name: 'R3',
  label: 'R3',
  value: '3'
}, {
  name: 'R4',
  label: 'R4',
  value: '4'
}, {
  name: 'N/A',
  label: 'N/A',
  value: '5'
}]



// WEBPACK FOOTER //
// ./src/AsbestosHazards.js